import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Users, Check, ShieldCheck, Download, CreditCard, Lock } from 'lucide-react';
export function HeroSection() {
  const [viewers, setViewers] = useState(39);
  useEffect(() => {
    const interval = setInterval(() => {
      // Fluctuate between 32 and 48
      setViewers(prev => {
        const change = Math.random() > 0.5 ? 1 : -1;
        const next = prev + change;
        if (next < 32) return 32;
        if (next > 48) return 48;
        return next;
      });
    }, 3500);
    return () => clearInterval(interval);
  }, []);
  return <section className="pt-8 pb-12 px-4 bg-[#F5F1E8] overflow-hidden" data-id="element-48">
      <div className="max-w-2xl mx-auto text-center" data-id="element-49">
        {/* Hero Title */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-3xl md:text-4xl font-extrabold text-[#1E3A5F] leading-tight mb-4" data-id="element-50">
          <span className="text-red-600" data-id="element-51">6 horas por día</span> frente a una
          pantalla están afectando su concentración…{' '}
          <span className="text-[#22C55E]" data-id="element-52">
            pero podés cambiar eso desde hoy.
          </span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="text-lg text-[#1E3A5F] mb-4 font-medium" data-id="element-53">
          MegaPack Anti-Pantallas es el sistema práctico que ya ayudó a más de
          10.000 familias a reducir el uso excesivo sin gritos ni peleas.
        </motion.p>

        {/* Credibility */}
        <p className="text-sm text-[#1E3A5F]/70 italic mb-6" data-id="element-54">
          Metodología basada en recomendaciones de especialistas en desarrollo
          infantil y hábitos digitales.
        </p>

        {/* Emotional Tagline */}
        <div className="bg-[#22C55E]/10 text-[#1E3A5F] font-bold py-2 px-4 rounded-lg inline-block mb-8 border border-[#22C55E]/20" data-id="element-55">
          Menos pantallas. Más atención. Más conexión real.
        </div>

        {/* Hero Image */}
        <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="mb-6 rounded-xl overflow-hidden shadow-xl border-4 border-white" data-id="element-56">
          <img src="https://cdn.magicpatterns.com/uploads/wyivGgKKQ2j5gejWbXLPhJ/HERO.png" alt="Niño usando tablet vs niño jugando y aprendiendo" className="w-full h-auto" data-id="element-57" />
        </motion.div>

        {/* Dynamic Viewer Counter */}
        <div className="flex items-center justify-center gap-2 text-red-600 font-bold mb-8 animate-pulse" data-id="element-58">
          <Users className="w-5 h-5" data-id="element-59" />
          <span data-id="element-60">🔥 {viewers} personas están viendo esta página ahora</span>
        </div>

        {/* Price Block */}
        <div className="bg-white rounded-2xl border-2 border-[#22C55E] p-6 relative shadow-xl mb-8" data-id="element-61">
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-1 rounded-full font-bold text-sm uppercase tracking-wide shadow-md" data-id="element-62">
            Oferta por tiempo limitado
          </div>

          <div className="mt-4 mb-6" data-id="element-63">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-64">
              <span className="text-2xl" data-id="element-65">🇦🇷</span>
              <p className="text-gray-500 text-lg line-through font-medium" data-id="element-66">
                Antes: $70.000 ARS
              </p>
            </div>

            {/* Breakdown */}
            <div className="text-sm text-[#1E3A5F] mt-2 mb-4 space-y-1 bg-[#F5F1E8] p-3 rounded-lg border border-gray-200 inline-block text-left w-full max-w-xs mx-auto" data-id="element-67">
              <div className="flex justify-between" data-id="element-68">
                <span data-id="element-69">MegaPack valor regular:</span>{' '}
                <span className="font-semibold" data-id="element-70">$40.000</span>
              </div>
              <div className="flex justify-between text-[#22C55E]" data-id="element-71">
                <span data-id="element-72">+ Bono 1 (Matemáticas):</span>{' '}
                <span className="font-semibold" data-id="element-73">$10.000</span>
              </div>
              <div className="flex justify-between text-[#22C55E]" data-id="element-74">
                <span data-id="element-75">+ Bono 2 (Emociones):</span>{' '}
                <span className="font-semibold" data-id="element-76">$10.000</span>
              </div>
              <div className="flex justify-between text-[#22C55E]" data-id="element-77">
                <span data-id="element-78">+ Bono 3 (Estimulación):</span>{' '}
                <span className="font-semibold" data-id="element-79">$10.000</span>
              </div>
              <div className="border-t border-gray-200 mt-2 pt-2 flex justify-between font-bold text-[#1E3A5F]" data-id="element-80">
                <span data-id="element-81">Total real:</span>
                <span data-id="element-82">$70.000</span>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center" data-id="element-83">
              <span className="text-[#1E3A5F] font-bold text-xl mb-1" data-id="element-84">
                PRECIO PROMOCIONAL
              </span>
              <div className="flex items-center justify-center gap-3" data-id="element-85">
                <span className="text-3xl" data-id="element-86">🇦🇷</span>
                <div className="text-5xl md:text-6xl font-black text-[#22C55E] tracking-tight" data-id="element-87">
                  $19.990
                </div>
              </div>
              <p className="text-sm text-gray-600 mt-1 font-medium" data-id="element-88">
                Pesos Argentinos (ARS)
              </p>
              <p className="text-red-600 font-bold mt-2 text-sm uppercase" data-id="element-89">
                ¡Ahorrás $50.010 hoy!
              </p>
            </div>
          </div>

          <p className="text-[#1E3A5F] font-medium mb-6" data-id="element-90">
            Acceso completo + 3 bonos incluidos por tiempo limitado.
          </p>

          {/* Bonus Images Grid */}
          <div className="grid grid-cols-4 gap-2 mb-6" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/7Jv72eKj5jpWYam3DBFiPu/portada_kit_educativo_completo.png" alt="Kit Completo" className="rounded-md shadow-sm border border-gray-200" data-id="element-92" />
            <img src="https://cdn.magicpatterns.com/uploads/3K9eSrJRrSVP8QEoERsAqM/portada_bono_1_matematicas_inicial.jpg" alt="Bono Matemáticas" className="rounded-md shadow-sm border border-gray-200" data-id="element-93" />
            <img src="https://cdn.magicpatterns.com/uploads/s8RQP1Y3ToNCVU3RjaoVes/portada_bono_2_emociones_y_conductas.jpg" alt="Bono Emociones" className="rounded-md shadow-sm border border-gray-200" data-id="element-94" />
            <img src="https://cdn.magicpatterns.com/uploads/95n5oFKsqxv2Dpvs7wteLa/portada_bono_3_estimulacion_temprana.png" alt="Bono Estimulación" className="rounded-md shadow-sm border border-gray-200" data-id="element-95" />
          </div>

          {/* Secure Payment Badge */}
          <div className="flex items-center justify-center gap-2 mb-4 bg-[#F5F1E8] py-2 px-4 rounded-lg border border-[#22C55E]/20" data-id="element-96">
            <Lock className="w-5 h-5 text-[#22C55E]" data-id="element-97" />
            <span className="font-bold text-[#1E3A5F] text-sm uppercase tracking-wide" data-id="element-98">
              Pago 100% Seguro
            </span>
          </div>

          {/* Main CTA */}
          <motion.a href="https://mpago.li/2MQSj3Q" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-[#22C55E] hover:bg-[#16A34A] text-white font-bold text-xl md:text-2xl py-4 px-6 rounded-xl shadow-lg transition-colors mb-4 animate-[pulse_2s_infinite]" data-id="element-99">
            COMPRAR AHORA
            <span className="block text-sm font-normal opacity-90 mt-1" data-id="element-100">
              ACCESO INMEDIATO
            </span>
          </motion.a>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-3 text-xs md:text-sm text-[#1E3A5F] font-medium mb-4" data-id="element-101">
            <div className="flex items-center gap-1" data-id="element-102">
              <Check className="w-4 h-4 text-[#22C55E]" data-id="element-103" /> Acceso inmediato
            </div>
            <div className="flex items-center gap-1" data-id="element-104">
              <Download className="w-4 h-4 text-[#22C55E]" data-id="element-105" /> Descarga
              automática
            </div>
            <div className="flex items-center gap-1" data-id="element-106">
              <ShieldCheck className="w-4 h-4 text-[#22C55E]" data-id="element-107" /> Pago 100%
              seguro
            </div>
          </div>

          <div className="text-xs text-gray-500 bg-gray-100 py-2 px-4 rounded-full inline-block" data-id="element-108">
            Últimas 24 horas:{' '}
            <span className="font-bold text-gray-900" data-id="element-109">137 compras</span>
          </div>
        </div>
      </div>
    </section>;
}